var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef } from 'react';
import { Button } from '@mui/material';
import omit from 'lodash/omit';
import { ACCEPTABLE_FILE_UPLOAD_TYPES } from '../constants/common';
export var UploadError;
(function (UploadError) {
    UploadError["MAX_SIZE_ERROR"] = "MAX_SIZE_ERROR";
    UploadError["WRONG_FILE_TYPE"] = "WRONG_FILE_TYPE";
})(UploadError || (UploadError = {}));
var defaultMaxFileUploadSizeAllowedInMB = 30;
var DocumentUploadButton = function (props) {
    var _a, _b, _c;
    var fileUploadRef = useRef(null);
    var handleFileUploadFromLocal = function (event) {
        var _a, _b, _c, _d;
        var files = event.target.files;
        console.log(files);
        if (!files)
            return;
        var file = files[0];
        if (!(props.accept || ACCEPTABLE_FILE_UPLOAD_TYPES).split(',').includes(file.type)) {
            (_a = props.onFileUploadWarning) === null || _a === void 0 ? void 0 : _a.call(props, {
                error: UploadError.WRONG_FILE_TYPE,
                type: file.type
            });
            if (fileUploadRef.current) {
                fileUploadRef.current.value = '';
            }
            return;
        }
        if ((file === null || file === void 0 ? void 0 : file.size) > ((_b = props.maxFileUploadSizeAllowedInMB) !== null && _b !== void 0 ? _b : defaultMaxFileUploadSizeAllowedInMB) * 1000000) {
            (_c = props.onFileUploadWarning) === null || _c === void 0 ? void 0 : _c.call(props, {
                error: UploadError.MAX_SIZE_ERROR,
                size: file === null || file === void 0 ? void 0 : file.size
            });
            if (fileUploadRef.current) {
                fileUploadRef.current.value = '';
            }
            return;
        }
        (_d = props.onUpload) === null || _d === void 0 ? void 0 : _d.call(props, file);
        if (fileUploadRef.current) {
            fileUploadRef.current.value = '';
        }
    };
    var handleUpload = function () {
        var _a;
        (_a = fileUploadRef === null || fileUploadRef === void 0 ? void 0 : fileUploadRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { type: 'file', ref: fileUploadRef, className: "lfc-hidden", onChange: handleFileUploadFromLocal, accept: (_a = props.accept) !== null && _a !== void 0 ? _a : ACCEPTABLE_FILE_UPLOAD_TYPES }),
        React.createElement(Button, __assign({ variant: "contained", disableElevation: true }, omit(props.buttonProps, 'sx'), { sx: __assign({ textTransform: 'none' }, (_b = props.buttonProps) === null || _b === void 0 ? void 0 : _b.sx), onClick: handleUpload }), (_c = props.uploadButtonTitle) !== null && _c !== void 0 ? _c : 'Upload')));
};
export default DocumentUploadButton;
//# sourceMappingURL=DocumentUploadButton.js.map